import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import ButtonLink from "~/components/links/ButtonLink";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

import { h3, h4 } from "~/styles/typographyStyles";

export const ColumnTitle = styled.h3`
    ${h3};
    color: ${({ theme }) => theme.palette.white};
`;

export const Copy = styled.h4`
    ${h4};
    color: ${({ theme }) => theme.palette.white};
    margin-bottom: ${({ theme }) => theme.layout.largeGutter};
`;

const ButtonWrapper = styled.div`
    margin-bottom: 15px;
`;

export const Text = styled.div`
    color: ${({ theme }) => theme.palette.white};
    font-size: 1.5rem;
    font-weight: 900;

    a {
        color: ${({ theme }) => theme.palette.white};
        text-decoration: underline;
    }
`;

const Expert = ({
    title = "",
    copy = "",
    buttonLabel = "",
    buttonUrl = "",
    callText = "",
}) => (
    <>
        {title ? <ColumnTitle>{title}</ColumnTitle> : null}
        {copy ? <Copy>{copy}</Copy> : null}
        {buttonLabel && buttonUrl ? (
            <ButtonWrapper>
                <ButtonLink to={buttonUrl}>{buttonLabel}</ButtonLink>
            </ButtonWrapper>
        ) : null}
        {callText ? <Text>{sanitizeAndParseHTML(callText)}</Text> : null}
    </>
);

Expert.propTypes = {
    title: PropTypes.string,
    copy: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonUrl: PropTypes.string,
    callText: PropTypes.string,
};

export default Expert;
